import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';
import { TimetableSubjectContainersSubpage } from './TimetableSubjectContainersSubpage';
import { TimetableSubjectGroupsSubpage } from './TimetableSubjectGroupsSubpage';
import { TimetableSubjectsSubpage } from './TimetableSubjectsSubpage';

export const TimetableSetupSubjectsAndSubjectContainer = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadTimetable()}>
      <TabBar
        variant='large'
        tabs={[
          {
            trigger: t('subject.title', { count: 2 }),
            id: 'subjects',
            content: <TimetableSubjectsSubpage />,
          },
          {
            trigger: t('subjectContainer.title', { count: 2 }),
            id: 'subjectsContainer',
            content: <TimetableSubjectContainersSubpage />,
          },
          {
            trigger: t('subjectGroup.title', { count: 2 }),
            id: 'subjectGroup',
            content: <TimetableSubjectGroupsSubpage />,
          },
        ]}
      />
    </Page>
  );
};
